import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import { MainCard, MainCardContent, MainCardTitle } from "src/components/main-card-type.tsx"
import {
    checkCalculatorUsageLimitAndRedirect,
    loadSavedCalculatorData,
    sanitizeBrlValue,
    saveCalculatorData,
} from "src/utils/functions";

import { Button } from "src/components/ui/button";
import { CalculoFGTSResponse, Explicaçoes_Campos } from "../calcular-fgts.d";
interface TooltipProps {
    children: React.ReactNode;
    text: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, text }) => (
    <div className="relative group inline-block">
        {children}
        <div className="absolute  bottom-full left-full transform mb-2 px-3 py-2 w-80 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-500 text-center">
            {text}
        </div>
    </div>
);
export const CalculadoraFGTSInputCard = ({
    setResults,
}: {
    setResults: (value: CalculoFGTSResponse | null) => void;
}) => {

    const [message, setMessage] = useState<string>("");

    const [salariobruto, setSalariobruto] = useState("")
    const [saldoAnterior, setSaldoAnterior] = useState("")
    const [dataInicial, setDataInicial] = useState("")
    const [dataFinal, setDataFinal] = useState("")
    const [corrigindo, setCorrigindo] = useState(false)
    const calculatorKey = "calculadora-fgts";

    function clear() {
        setSalariobruto("");
        setSaldoAnterior("");
        setDataInicial("");
        setDataFinal("");
        setMessage("")
        setResults(null)
    }
    function handleSave() {
        saveCalculatorData(calculatorKey, {
            salariobruto,
            saldoAnterior,
            dataInicial,
            dataFinal,
        })
    }
    const isVerified = useIsVerified();
    useEffect(() => {
        const savedData = loadSavedCalculatorData(calculatorKey);
        if (!savedData) return;
        setSalariobruto((savedData.salariobruto as string) || "");
        setSaldoAnterior((savedData.saldoAnterior as string) || "")
        setDataInicial((savedData.dataInicial as string) || "")
        setDataFinal((savedData.dataFinal as string) || "")
    }, []);

    const handleOnChange = () => {
        setCorrigindo(!corrigindo)
    }

    function calcular() {
        if (!salariobruto) {
            setMessage("Adicione um valor ao Salario Bruto")
            setResults(null)
            return
        }
        if (!saldoAnterior) {
            setMessage("Adcione um valor ao Saldo Anterior")
            setResults(null)
            return
        }
        if (!dataFinal) {
            setMessage("Adicione uma data Final")
            setResults(null)
            return
        }
        if (!dataInicial) {
            setMessage("Adicione uma data Inicial")
            setResults(null)
            return
        }
        setMessage("")

        const ValorBruto = Number.parseFloat(
            salariobruto.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const AnoInicial = Number.parseFloat(
            dataInicial.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const MesInicial = Number(dataInicial.split("-")[1]);

        const AnoFinal = Number.parseFloat(
            dataFinal.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const MesFinal = Number(dataFinal.split("-")[1]); // "02" → 2

        const ValorAnterior = Number.parseFloat(
            saldoAnterior.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );



        let valorFinal: number = 0
        let meses: number = 0
        let depositomensal: number = 0
        let depositoTotal: number = 0
        let saldoCorrigido: number = 0


        depositomensal = ValorBruto * 0.08
        meses = (AnoFinal - AnoInicial) * 12 + (MesFinal - MesInicial) + 1
        depositoTotal = depositomensal * meses
        valorFinal = ValorAnterior + depositoTotal
        if (corrigindo === true) {
            let saldo = ValorAnterior;
            let taxaMensal: number = 0.004998679823979032;

            for (let i = 0; i < meses; i++) {
                saldo *= (1 + taxaMensal);
                saldo += depositomensal;
            }
            saldoCorrigido = Math.round(saldo * 100) / 100;
            console.log(saldoCorrigido, "Corrigido");
        }

        console.log(valorFinal);
        const resultado = {
            valorFinal: valorFinal,
            meses: meses,
            depositomensal: depositomensal,
            depositoTotal: depositoTotal,
            saldoCorrigido: saldoCorrigido

        }
        setResults(resultado);

    }

    return (
        <MainCard>
            <MainCardTitle>Calcular FGTS</MainCardTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSave();
                    checkCalculatorUsageLimitAndRedirect(calcular)
                }}>
                <MainCardContent>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
                            Salario Bruto *
                        </label>
                        <div className="flex border">
                            <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                                R$
                            </span>
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="bruto-id"
                                placeholder="00,00"
                                type="text"
                                value={salariobruto}
                                onChange={(event) => setSalariobruto(sanitizeBrlValue(event))}
                            />
                        </div>
                    </div>

                    <div>
                        <Tooltip text={Explicaçoes_Campos.saldo_Anterior}>
                            <label className="block mb-2 font-medium text-sm cursor-help" htmlFor="penultimo-salario">
                                Saldo Anterior * ℹ️
                            </label>
                        </Tooltip>
                        <div className="flex border">
                            <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                                R$
                            </span>
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="bruto-id"
                                placeholder="00,00"
                                type="text"
                                value={saldoAnterior}
                                onChange={(event) => setSaldoAnterior(sanitizeBrlValue(event))}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="meses-id">
                            Data da Admissão *
                        </label>
                        <div className="flex border">
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="meses-id"
                                placeholder="0"
                                type="date"
                                value={dataInicial}
                                onChange={(event) => setDataInicial((event.target.value))}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="meses-id">
                            Data do Desligamento *
                        </label>
                        <div className="flex border">
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="meses-id"
                                placeholder="0"
                                type="date"
                                value={dataFinal}
                                onChange={(event) => setDataFinal((event.target.value))}
                            />
                        </div>
                    </div>
                    <div>
                        <input type="checkbox" id="corrigido" onChange={handleOnChange} />
                        <Tooltip text={Explicaçoes_Campos.calculo_corrigido}>
                            <label className="pl-2" htmlFor="corrigido">Cálculo corrigido  ℹ️</label>
                        </Tooltip>
                    </div>
                </MainCardContent>
                <div className="flex justify-between">
                    <Button
                        disabled={!isVerified}
                        type="submit"
                        variant={"default"}
                        className="sm:w-[150px]"
                    >
                        Calcular
                    </Button>

                    <div className="flex flex-col sm:flex-row items-center gap-2">

                        <Button onClick={clear} type="button" variant={"ghost"}>
                            Limpar
                        </Button>
                    </div>
                </div>
            </form>
            <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
        </MainCard>
    )
} 